import classnames from 'classnames';
import React from 'react';
import { v4 as uuid } from 'uuid';

import CheckboxError from './CheckboxError';
import { CheckboxLabel } from './CheckboxLabel';
import CheckboxPanelOption from './CheckboxPanelOption';
import { CheckboxPanelProps } from './types';

const CheckboxPanels: React.FC<CheckboxPanelProps> = ({
    label,
    options,
    className,
    sublabel,
    infoButton,
    externalLinkLabel,
    error,
    ...rest
}) => (
    <fieldset className={classnames('sgw-checkbox-panels', className)} {...rest}>
        <CheckboxLabel
            label={label}
            sublabel={sublabel}
            infoButton={infoButton}
            externalLinkLabel={externalLinkLabel}
        />
        {options.map((option) => (
            <CheckboxPanelOption key={option.id ?? String(option.label) ?? uuid()} {...option} />
        ))}
        <CheckboxError error={error} />
    </fieldset>
);

export default CheckboxPanels;
